import BookItem from "../common/bookItem";
export default class VisibleSwitchAns extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.connectNumber = this.el.connectNumber;
        this.add_mouse_event();
        this.target.gotoAndStop(0);
    }

    init() {
        // 抓Connect子物件
        this.childGroup = this.itemControl.getItemsByClassConnect("ansshowbtnchild", this);
        // Connect子物件紀錄主按鈕
        // console.log("我是解答主按鈕~~");
        this.childGroup.forEach(element => {
            element.mainGroup.push(this);
        });
    }

    /**
     * 點擊
     */
    trigger() {
        this.isOpen = !this.isOpen;
        this.ProcessMainBtn();
        this.ProcessChildBtn();

        this.ChildNotice();
    }

    /**
     * 處理主按鈕
     */
    ProcessMainBtn() {
        if (this.isOpen == true) {
            // 現在要是全開狀態，全開
            this.target.gotoAndStop(3);
        }
        else if (this.isOpen == false) {
            // 現在要是全關狀態，全關
            this.target.gotoAndStop(0);
        }
    }

    /**
     * 處理子按鈕
     */
    ProcessChildBtn() {
        this.childGroup.forEach(element => {
            if (this.isOpen == true) {
                // 打開全部答案
                // 開啟答案
                if (element.notFirstFrame == true) {
                    element.target.gotoAndStop(0);
                }
                else {
                    element.target.gotoAndStop(1);
                }
                element.isOpen = this.isOpen;
            }
            else if (this.isOpen == false) {
                // 關閉答案
                // console.log(element.notFirstFrame);
                if (element.notFirstFrame == true) {
                    element.target.gotoAndStop(1);
                }
                else {
                    element.target.gotoAndStop(0);
                }
                element.isOpen = this.isOpen;

            }
        });
    }

    /**
     * 點擊事件
     */
    add_mouse_event() {
        this.target.removeAllEventListeners();
        this.target.mouseChildren = false;
        this.target.addEventListener("click", () => {
            this.trigger();
            this.nowBtnIndex = this.isOpen ? 3 : 0;
            // this.target.gotoAndStop(this.nowBtnIndex);
        });
        this.target.addEventListener("mouseover", () => {
            // TODO : this.nowBtnIndex == 3 目的是點選狀態時不要有滑入滑出效果，有問題須刪掉改方法
            if (this.nowBtnIndex == 1 || this.nowBtnIndex == 3) return;
            this.nowBtnIndex = 1;
            this.target.gotoAndStop(this.nowBtnIndex);
            this.itemControl.loader.singleAntialiasing(this.target);
        });
        this.target.addEventListener("mouseout", () => {
            this.nowBtnIndex = this.isOpen ? 3 : 0;
            this.target.gotoAndStop(this.nowBtnIndex);
            this.itemControl.loader.singleAntialiasing(this.target);
        });
        this.target.addEventListener("mousedown", () => {
            this.nowBtnIndex = 2;
            this.target.gotoAndStop(this.nowBtnIndex);
            this.itemControl.loader.singleAntialiasing(this.target);
        });
    }
    
    /**
     * 主按鈕檢查群子按鈕
     */
    TestCheck(){
        // console.log("Testcheck", this);
        let allOpenSucess = true;
        // 檢查全部底下子物件，有沒開的就 allOpenSucess = false;
        this.childGroup.forEach(element => {
            if (element.isOpen == false) {
                allOpenSucess = false;
                this.isOpen = false;
                this.target.gotoAndStop(0);
                return;
            }
        });
        // 有全開，物件做子物件全開時要做的事
        if (allOpenSucess) {
            this.isOpen = true;
            this.target.gotoAndStop(3);
        }
    }


    // TIP : 要做判斷控制全開或全關
    ControlTrigger(state){
        // console.log("state",state);
        this.isOpen = state;

        // 要全開的話
        if (state) {
            // console.log("ControlTrigger","全開");
            this.target.gotoAndStop(3);

            this.childGroup.forEach(element => {

                if (element.notFirstFrame == true) {
                    element.target.gotoAndStop(0);
                }
                else {
                    element.target.gotoAndStop(1);
                }
                element.isOpen = state;
            });
        }
        else{
            // console.log("ControlTrigger","全關");
            this.target.gotoAndStop(0);

            this.childGroup.forEach(element => {
                
                if (element.notFirstFrame == true) {
                    element.target.gotoAndStop(1);
                }
                else {
                    element.target.gotoAndStop(0);
                }
                element.isOpen = state;
            });
        }
    }
}